import request from '../Functions/ajax/request'

export default function ArticleLoader ({ params })
{
	return { page: getNews({ params }) };
}

async function getNews ({ params })
{
	const slug_article = params.slug;

	try
	{
		var { news: article } = await request('/news/get')
		.config({ })
		.post({ slug: slug_article });
	}
	catch (update)
	{
		console.error(update);
	}

	try
	{
		var { data } = await request('/news/get-last-news')
		.config({ })
		.post({ skip: 0, limit: 5 });
	}
	catch (update)
	{
		console.error(update);
	}

	return { article, articles_recents: data || [] };
}